import React from 'react'
import Contact from '../components/Contact/Contact'
import Navbar from '../components/Home/Navbar/Navbar'
import Footer from '../components/Home/Footer/Footer'

const Contactpage = () => {
    return (
        <div>
            <Navbar />
            <main>
            <Contact />
            </main>
            <Footer/>

        </div>
    )
}

export default Contactpage
